<template>
    <div class="warehouse-registration-page">
        <base-header
            class="warehouse-registration-page__header"
            :titulo="translate('main_title')"
            icon="el-icon-document-add"
            :exibe-botao="false"
            :voltarPara='true'
        />
        <div class="view-container-wrapper">
            <div class="content">
                <search-filters @changeFilters="changeFilters" />
                <company-warehouse-list
                    v-if="filters.length !== 0"
                    :filters="filters"
                />
            </div>
        </div>
    </div>
</template>

<script>
import BaseHeader from '@/components/BaseHeader.vue';
import SearchFilters from '@/modules/warehouse/views/pages/companyWarehouseRegistration/components/filters/index.vue';
import CompanyWarehouseList from '@/modules/warehouse/views/pages/companyWarehouseRegistration/components/company-warehouse-registration-list/index.vue';

export default {
    name: 'WarehouseRegistrationPage',
    components: {
        BaseHeader,
        SearchFilters,
        CompanyWarehouseList
    },
    computed: {
    },
    mounted() {
    },
    data() {
        return {
            filters: {}
        };
    },
    watch: {
    },
    methods: {
        translate(key, params = {}) {
            const base = 'warehouse.warehouse_registration_page';
            return this.$t(`${base}.${key}`, params);
        },
        changeFilters(filters) {
            this.filters = filters;
        }
    }
};
</script>

<style scoped lang="scss">
.warehouse-registration-page {
    .view-container-wrapper {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .content {
        display: flex;
        flex-direction: column;
        gap: 16px;
        padding: 16px;
    }
}

</style>
